import React, { useCallback, useEffect, useState } from 'react';

import { Heading } from '@uk-source-web/heading';
import { Icon } from '@uk-source-web/icon';

import { TenantPortingOrderConfirmationProps } from './TenantPortingOrderConfirnmation.types';
import {
  TenantPortingContainer,
  TenantPortingHeader,
  TenantPortingItemsWrapper,
} from './TenantPortingOrderConfirmation.styles';
import TenantPortingItem from './TenantPortingProducts/TenantPortingItem';
import { useAppSelector } from '@/store';

const TenantPortingOrderConfirmation = ({
  title,
  tenantPortingStatus,
  heading,
  calloutMessages,
  calloutMessageNonMsft,
}: TenantPortingOrderConfirmationProps) => {
  const { userBasket } = useAppSelector(({ userBasket: { data } }) => ({
    userBasket: data,
  }));

  return (
    <TenantPortingContainer>
      <TenantPortingHeader>
        {tenantPortingStatus === 'success' ? (
          <>
            <Heading size={3} weight={4}>
              {title}
            </Heading>
            <Icon name={'tick-outline'} group="hifiLight" />
          </>
        ) : (
          <>
            <Heading size={3} weight={4}>
              {title}
            </Heading>
            <Icon name={'error'} group="state" />
          </>
        )}
      </TenantPortingHeader>
      <hr style={{ border: 'none', borderTop: '1px solid #7E7E7E', margin: '10px 0' }} />
      {/* Render Microsoft items first */}
      {userBasket.items
        .filter(product => product.msftProduct)
        .map(product => {
          const initiallyOpenIds = userBasket.items.length === 1 ? [product.id] : [];
          return (
            <TenantPortingItemsWrapper key={product.id}>
              <TenantPortingItem
                key={product.id}
                {...product}
                calloutMessages={calloutMessages}
                calloutMessageNonMsft={calloutMessageNonMsft}
                initiallyOpenIds={initiallyOpenIds}
              />
            </TenantPortingItemsWrapper>
          );
        })}

      {/* Single heading before non-Microsoft items */}
      {userBasket.items.some(product => !product.msftProduct) && (
        <Heading size={2} weight={4}>
          {heading}
        </Heading>
      )}

      {/* Render non-Microsoft items after the heading */}
      {userBasket.items
        .filter(product => !product.msftProduct)
        .map(product => {
          const initiallyOpenIds = userBasket.items.length === 1 ? [product.id] : [];
          return (
            <TenantPortingItemsWrapper>
              <TenantPortingItem
                key={product.id}
                {...product}
                calloutMessages={calloutMessages}
                calloutMessageNonMsft={calloutMessageNonMsft}
                initiallyOpenIds={initiallyOpenIds}
              />
            </TenantPortingItemsWrapper>
          );
        })}
    </TenantPortingContainer>
  );
};

export default TenantPortingOrderConfirmation;
